import { zodResolver } from '@hookform/resolvers/zod';
import * as React from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { Alert, Button, FormField, Input } from '@payment-plan/ui';
import { AuthCard, ENLACE_CLASS } from './AuthCard';
import { recuperarSchema, type RecuperarValues } from './contrasena';
import { ApiError, apiClient } from '../../lib/api-client';

export const MENSAJE_RECUPERAR_ENVIADO =
  'Si el correo está registrado, te enviamos un enlace para definir una nueva contraseña. Revisa tu bandeja de entrada.';

/**
 * fix-60 · alcance extra del dev: pantalla pública «¿Olvidaste tu contraseña?». La respuesta es la
 * misma exista o no el correo (el back no revela cuentas).
 */
export function RecuperarPage(): React.JSX.Element {
  const [enviado, setEnviado] = React.useState(false);
  const [serverError, setServerError] = React.useState<string | null>(null);
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<RecuperarValues>({ resolver: zodResolver(recuperarSchema), defaultValues: { correo: '' } });

  const onSubmit = handleSubmit(async ({ correo }) => {
    setServerError(null);
    try {
      await apiClient.requestPasswordReset(correo);
      setEnviado(true);
    } catch (error) {
      setServerError(
        error instanceof ApiError && error.status === 429
          ? 'Demasiadas solicitudes. Espera un momento e inténtalo de nuevo.'
          : 'No fue posible enviar el enlace. Inténtalo de nuevo.',
      );
    }
  });

  return (
    <AuthCard title="Recuperar contraseña" description="Te enviaremos un enlace para definir una nueva contraseña.">
      {enviado ? (
        <div className="space-y-4">
          <Alert variant="success" role="status">
            {MENSAJE_RECUPERAR_ENVIADO}
          </Alert>
          <p className="text-center">
            <Link to="/login" className={ENLACE_CLASS}>
              Volver a iniciar sesión
            </Link>
          </p>
        </div>
      ) : (
        <form className="space-y-5" onSubmit={(event) => void onSubmit(event)} noValidate>
          <FormField label="Correo" htmlFor="correo" required error={errors.correo?.message}>
            <Input id="correo" type="email" autoComplete="email" autoFocus error={Boolean(errors.correo)} {...register('correo')} />
          </FormField>
          {serverError && <Alert variant="destructive" role="alert">{serverError}</Alert>}
          <Button className="w-full" type="submit" disabled={isSubmitting} loading={isSubmitting}>
            {isSubmitting ? 'Enviando...' : 'Enviar enlace'}
          </Button>
          <p className="text-center">
            <Link to="/login" className={ENLACE_CLASS}>
              Volver a iniciar sesión
            </Link>
          </p>
        </form>
      )}
    </AuthCard>
  );
}
